/**
 * Which meeting a location setting applies to.
 *
 * A debrief is a single meeting with a single host, so the debrief variant intentionally drops three
 * things the interview variant offers — the candidate-phone location type, the `INTERVIEWERS` dynamic
 * host, and the video-meeting-link scope. The backend validator
 * (`ValidatorUtils.validateDebriefMeetingLocationSettingPref`) hard-rejects all three for debrief
 * prefs, so they must never be selectable or sent.
 */
export enum InterviewMeetingLocationVariant {
  INTERVIEW = 'INTERVIEW',
  DEBRIEF = 'DEBRIEF',
}
